import { type Authorization, type Credentials, type User } from '@scoring/types';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface AuthenticationState {
    user?: User;
    credentials?: Credentials;
    authorization?: Authorization;
    hydrated?: boolean;

    authorize: (authorization: Authorization) => void;
    login: (credentials: Credentials) => void;
    setUser: (user: User) => void;
    logout: () => void;
}

export const useAuthenticationStore = create<AuthenticationState>()(
    devtools(
        persist(
            immer((set) => ({
                user: undefined,
                credentials: undefined,
                authorization: undefined,
                hydrated: false,
                authorize: (authorization: Authorization) => {
                    // Token is now read directly from store by API package
                    set((state) => {
                        state.authorization = authorization;
                    });
                },
                login: (credentials: Credentials) => {
                    set((state) => {
                        state.credentials = credentials;
                    });
                },
                setUser: (user: User) => {
                    set((state) => {
                        state.user = user;
                    });
                },
                logout: () => {
                    // Token is now read directly from store by API package
                    set((state) => {
                        state.authorization = undefined;
                        state.user = undefined;
                        state.credentials = { email: state.credentials?.email ?? '', password: '' };
                    });
                },
            })),
            {
                name: 'authentication-store',
                onRehydrateStorage() {
                    console.log('hydration starts');

                    // optional
                    return (state, error) => {
                        if (error) {
                            console.log('an error happened during hydration', error);
                        } else {
                            console.log('hydration finished', state);
                            // Token is now read directly from store by API package
                            if (state) state.hydrated = true;
                        }
                    };
                },
            }
        )
    )
);
